import { queryOptions } from "@tanstack/react-query";
import { listNamespaces } from "../api/listNamespaces";

const vectorQueries = {
    allNamespaces: () => queryOptions({
        queryKey: ['namespaces'],
        queryFn: listNamespaces
    })
}

export { vectorQueries }